import * as Html from "../util/Html.ts";
export {init}
Html.registerWidget('widget/select-role',{init:init})

  function toogleInputBuilder(option,select,input){
    return function(useFocus){
      if(option.prop('selected')){
        input.prop('disabled',false);
        input.show();
        select.hide();
        if(useFocus){
          input.focus();  
        }
      }else{
        input.prop('disabled',true);
        select.show();
        input.hide();
      }
    };
  }
  function init(option){
    var
      select = option.parent(),  
      input = select.closest('form').find(option.attr("data-fw-extra-input")),
      toogleInput = toogleInputBuilder(option,select,input);

    input.blur(function(){
      if(!input.prop('disabled') && $(this).val().trim()===''){
        select.val('Unknown');
        toogleInput();
      }
    });
    select.change(toogleInput);
    toogleInput();
    
  }



  